/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Compose_Refine_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Anything to add? Leave empty to just improve it" |
*
* @param {Uno_Compose_Refine_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_compose_refine_placeholder = /** @type {((inputs?: Uno_Compose_Refine_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Compose_Refine_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch etwas ergänzen? Leer lassen, um nur zu verbessern")
	return /** @type {LocalizedString} */ ("Anything to add? Leave empty to just improve it")
});